import { OverlayScrollbarsComponent } from 'overlayscrollbars-react';
import styled from 'styled-components';

import { Avatar, Popup, TextInput } from '@sternum/ui';
import { Text } from '@sternum/web/components';
import { Colors } from '@sternum/web/components/theme/constants';
import { ct } from '@sternum/web/utils/theme';

export const AvatarStyled = styled(Avatar)<{ $selected?: boolean }>`
  flex-shrink: 0;
  border: ${(props) => (props.$selected ? `1px solid ${Colors.GreyLighter}` : `1px solid ${Colors.DarkerText}`)};
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
`;

export const SearchInput = styled(TextInput)`
  background: none;
  border: none;
  border-radius: 0;
  border-bottom: 1px solid ${ct({ Light: Colors.GreyDarker, Dark: Colors.GreyDarker })};
`;

export const PopupStyled = styled(Popup)`
  padding: 6px 0;
  width: 250px;
  border-radius: 0 0 6px 6px;
  background: ${ct({ Dark: Colors.DarkerText, Light: Colors.DarkerText })};
`;

export const PopupInner = styled(OverlayScrollbarsComponent)`
  width: 100%;
  max-height: 140px;
`;

export const NoResultsMessage = styled(Text)`
  font-size: 12px;
  color: ${ct({ Dark: Colors.GreyDarkerMiddle, Light: Colors.GreyDarkerMiddle })};
`;
